'use client'

import { useHomeTransactionalExposeEvents } from '@marketplace-web/escrow-pricing/escrow-pricing-feature'
import { HomepageBlocksModel } from '@marketplace-web/domain/home-page-data'

import BlocksFetcher from '../BlocksFetcher'
import HomeBlocks from '../HomeBlocks'
import { useHomeContext } from '../HomeProvider'
import HomeLoader from '../common/HomeLoader'
import useFetchHomepageBlocks from '../hooks/useFetchHomepageBlocksNew'

type Props = {
  initialData: HomepageBlocksModel
}

const HomeContent = ({ initialData }: Props) => {
  const { isLoading } = useHomeContext()
  const { blocks, areBlocksLoading, fetchMoreBlocks } = useFetchHomepageBlocks({ initialData })

  const hasNextPage = !!blocks?.nextPageToken
  const showLoader = (hasNextPage && !blocks?.showLoadMoreButton) || areBlocksLoading

  useHomeTransactionalExposeEvents()

  if (isLoading) return <HomeLoader />

  return (
    <>
      {/* TODO move children to `HomeContent` folder */}
      {blocks && <HomeBlocks blocks={blocks} />}
      {hasNextPage && !areBlocksLoading && (
        <BlocksFetcher
          fetchMoreBlocks={fetchMoreBlocks}
          showLoadMoreButton={blocks.showLoadMoreButton}
        />
      )}
      {showLoader && <HomeLoader />}
    </>
  )
}

export default HomeContent
